/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Categories that describe the workspace using WorkspaceCategoryEnum values.
 * @export
 * @enum {string}
 */
export const WorkspaceCategoryEnum = {
    Actor: 'actor',
    Artist: 'artist',
    BroadcasterRadio: 'broadcasterRadio',
    BroadcasterTv: 'broadcasterTV',
    Charity: 'charity',
    CollectionAgent: 'collectionAgent',
    CollectionSociety: 'collectionSociety',
    Distributor: 'distributor',
    Director: 'director',
    EducationalBody: 'educationalBody',
    Financier: 'financier',
    GovernmentBody: 'governmentBody',
    CompletionGuarantor: 'completionGuarantor',
    Investor: 'investor',
    Network: 'network',
    OffsetLender: 'offsetLender',
    PostFacility: 'postFacility',
    Producer: 'producer',
    ProductionCompany: 'productionCompany',
    SalesAgent: 'salesAgent',
    ScriptWriter: 'scriptWriter',
    SportingBody: 'sportingBody',
    Studio: 'studio',
    TalentAgent: 'talentAgent',
    Agency: 'agency',
    Other: 'other',
};
